import Utils from '../../modules/utils'

const getCadBuyerReviews = (cadId, callbackFunc) => {
  Utils.get('cad_buyer_reviews/' + cadId, callbackFunc)
}

const updateCadBuyerReviews = (cadId, deleteItems, addItems, callbackFunc) => {
  const data = {cadId, deleteItems, addItems}
  Utils.post('cad_buyer_reviews', data, callbackFunc)
}

const bulkCreateCadBuyerReviews = (cadIds, accountName, reviewDate, comment, callbackFunc) => {
  const data = {cadIds, accountName, reviewDate, comment}
  Utils.post('cad_buyer_reviews_bulk', data, callbackFunc)
}

export {getCadBuyerReviews, updateCadBuyerReviews, bulkCreateCadBuyerReviews}
